import styled from "@emotion/styled";
import { Props } from "react-select";
import { theme } from "Styles";

export const RadioContainer = styled.div<{ horizontal: boolean }>`
    display: ${(props) => (props.horizontal ? "flex" : "block")};
    align-items: flex-end;
    .radio {
        margin-right: ${(props) => (props.horizontal ? "30px" : 0)};
        margin-top: 0.5rem;
        margin-bottom: ${(props) => (props.horizontal ? "0" : "0.5rem")};
        label {
            &:before {
                border: 1px solid ${theme.palette.tableHeader.main} !important;
                box-shadow: none !important;
            }
        }

        input[type="radio"] {
            /*position: absolute;*/
            opacity: 0;
            white-space: nowrap;
            + .radio-label {
                &:before {
                    content: "";
                    border-radius: 100%;
                    border: 1px solid ${theme.palette.field.light};
                    display: inline-block;
                    width: 2em;
                    height: 2em;
                    position: relative;
                    top: -0.2em;
                    margin-right: 1em;
                    vertical-align: top;
                    cursor: pointer;
                    text-align: center;
                    transition: all 500ms ease-out;
                    box-shadow: inset 0 0 0 1px ${theme.palette.field.light};
                }
            }
            &:checked {
                + .radio-label {
                    &:before {
                        background-color: ${theme.palette.secondary.main};
                        box-shadow: inset 0 0 0 3px white;
                    }
                }
            }
            &:hover {
                + .radio-label {
                    &:before {
                        outline: none;
                        border: 1px solid black;
                    }
                }
            }
            &:focus {
                + .radio-label {
                    &:before {
                        outline: none;
                        border-color: ${theme.palette.secondary.main};
                    }
                }
            }
            &:disabled {
                + .radio-label {
                    &:before {
                        box-shadow: inset 0 0 0 4px ${theme.palette.field.light};
                        border-color: darken(${theme.palette.field.light}, 25%);
                        background: darken(${theme.palette.field.light}, 25%);
                    }
                }
            }
            + .radio-label {
                &:empty {
                    &:before {
                        margin-right: 0;
                    }
                }
            }
        }
    }
`;
